import Cookies from 'js-cookie'
import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { RefreshTokenFromOtpDocument } from 'api/hooks'
import { client } from 'utils/apollo'

export const isLogin = () => {
  return !!getAuthToken()
}

export const getAuthToken = (): string => {
  return Cookies.get('wwl-token') ?? ''
}

export const getRefreshToken = (): string => {
  return Cookies.get('wwl-token_r') || null
}

export const setTokens = (token: string, refreshToken: string) => {
  Cookies.remove('wwl-token')
  Cookies.remove('wwl-token_r')

  Cookies.set('wwl-token', token, { expires: 30 })
  Cookies.set('wwl-token_r', refreshToken, { expires: 90 })
}

export const removeTokens = () => {
  Cookies.remove('wwl-token')
  Cookies.remove('wwl-token_r')
}

/**
 * Обрабатывает токен из URL параметров
 * Если токен найден и валидный - устанавливает его в cookie и очищает URL
 */
export const processUrlToken = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url)
  const otpToken = url.searchParams.get('otpToken')

  if (!otpToken) {
    return null
  }

  if (!isValidToken(otpToken)) {
    return null
  }

  const { data } = await client.mutate({
    mutation: RefreshTokenFromOtpDocument,
    variables: { otp: otpToken },
  })

  const { token, refreshToken } = data?.refreshTokenFromOTP ?? {}

  try {
    if (token && refreshToken) {
      setTokens(token, refreshToken)
    }

    url.searchParams.delete('otpToken')

    const cleanUrl = url.pathname + url.search + url.hash
    return redirect(cleanUrl)
  } catch (error) {
    return null
  }
}

/**
 * Базовая валидация JWT токена
 */
const isValidToken = (token: string): boolean => {
  if (!token || typeof token !== 'string' || token.trim().length === 0) {
    return false
  }

  const parts = token.split('.')
  if (parts.length !== 3) {
    return false
  }

  try {
    const header = JSON.parse(
      atob(parts[0].replace(/-/g, '+').replace(/_/g, '/'))
    )
    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    )

    if (!header.alg || !payload.exp) {
      return false
    }

    const currentTime = Math.floor(Date.now() / 1000)
    if (payload.exp < currentTime) {
      return false
    }

    return true
  } catch (error) {
    return false
  }
}
